// GlobalRadioButton.jsx
import React from "react";

const GlobalRadioButton = ({
  activeType,
  setActiveType,
  leftLabel,
  rightLabel,
  t,
  ariaLabel = "Global switch",
}) => {
  const isLeftActive = activeType === leftLabel;
  const isRightActive = activeType === rightLabel;

  return (
    <div
      className="global-radio-toggle"
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {/* Slider pill */}
      <div
        className={
          "global-radio-toggle__pill " +
          (isRightActive ? "is-right" : "is-left")
        }
      />

      {/* LEFT */}
      <button
        type="button"
        role="radio"
        aria-checked={isLeftActive}
        className={
          "global-radio-toggle__option " +
          (isLeftActive ? "is-active" : "")
        }
        onClick={() => setActiveType(leftLabel)}
      >
        {t(leftLabel)}
      </button>

      {/* RIGHT */}
      <button
        type="button"
        role="radio"
        aria-checked={isRightActive}
        className={
          "global-radio-toggle__option " +
          (isRightActive ? "is-active" : "")
        }
        onClick={() => setActiveType(rightLabel)}
      >
        {t(rightLabel)}
      </button>
    </div>
  );
};

export default GlobalRadioButton;
